import { Diluent } from "../../../../models/Diluent";

export const getDiluentId = ({
  number,
  lotNumber,
}: Pick<Diluent, "number" | "lotNumber">) => {
  return `${number ?? ""}-${lotNumber ?? ""}`;
};
